import React, { useState, useEffect } from 'react';
import AppGrid from './AppGrid/AppGrid';
import TopBar from './TopBar/TopBar';
import AppGroupGrid from './AppGroupGrid/AppGroupGrid';
import { checkForToken, login } from '../loginHelpers';

function Dashboard() {
  const [jwt, setJwt] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = checkForToken();
    if (!token || !token.accessToken) {
      login();
    } else if (token.tokenError) {
      setError(token.tokenError);
    } else {
      setJwt(token);
    }
  }, []);

  if (error) {
    return <div>Error with accessToken: {error}</div>;
  }

  if (!jwt) {
    return <div />;
  }

  return (
    <div>
      <TopBar />
      <AppGroupGrid>
        <AppGrid type="Costing" />
      </AppGroupGrid>
      <AppGroupGrid>
        <AppGrid type="Material" />
      </AppGroupGrid>
    </div>
  );
}

export default Dashboard;
